import { simulateClick, setAttributes } from 'helpers/utils';

class BrandSlider {
    constructor(target) {
        this.state = {
            target,
            allBrandSliders: Array.from(
                target.getElementsByClassName('brand-slider__scroll-wrapper'),
            ),
            arrow: Array.from(target.getElementsByClassName('brand-slider__arrow')),
            disabled: 'brand-slider__arrow--disabled',
            screens: {
                vw1200: [100 / 6, 6],
                vw960: [100 / 3, 3],
                vw680: [50, 2],
            },
            brandScreens: {
                vw1200: [100 / 6, 6],
                vw960: [100 / 3, 3],
                vw680: [50, 2],
            },
            offset: null,
            resizeTimer: null,
            screenSize: null,
            currentSize: null,
            currentView: null,
            currentBrandSize: null,
            currentBrandView: null,
            sliderInterval: null,
            blockTotal: null,
            enableScroll: false,
            brandRight: null,
        };
    }

    // ==================================================
    // HANDLERS
    // ==================================================

    slider(el) {
        const { target } = this.state;
        const _slider = target.getElementsByClassName('brand-slider__scroll-wrapper')[0];
        const direction = el.classList.contains('js--f-right') ? 'right' : 'left';
        const blockMax = this.state.blockTotal - this.state.currentBrandView;

        let transformSize = null;
        this.state.offset = parseInt(target.getAttribute('data-offset'), 10);
        const forwardArrow = target.getElementsByClassName('brand-slider__arrow--disabled')[0];

        if (forwardArrow !== undefined && blockMax > 0) {
            forwardArrow.classList.remove(this.state.disabled);
        }

        if (
            (direction === 'right' && this.state.offset < blockMax) ||
            (direction === 'left' && this.state.offset > 0)
        ) {
            if (direction === 'right') {
                this.state.offset += 1;
            } else {
                this.state.offset -= 1;
            }

            transformSize = `${this.state.offset * this.state.currentBrandSize * -1}%`;
            _slider.style.transform = `translateX(${transformSize})`;
        }

        if (this.state.offset === blockMax || this.state.offset < 1) {
            el.classList.add(this.state.disabled);
        }

        if (this.state.offset > blockMax) {
            this.state.offset = blockMax;
        }

        if (this.state.offset < 0) {
            this.state.offset = 0;
        }

        target.setAttribute('data-offset', this.state.offset);
    }

    throttleOrDie() {
        clearTimeout(this.state.resizeTimer);
        this.state.resizeTimer = setTimeout(() => this.gridResize(), 250);
    }

    gridResize(val) {
        this.state.screenSize = `vw${parseInt(
            getComputedStyle(document.getElementsByClassName('js--fp-width')[0])['max-width'],
            10,
        )}`;

        const [size] = this.state.screens[this.state.screenSize];
        const [brandSize] = this.state.brandScreens[this.state.screenSize];

        if (size !== this.state.currentSize) {
            this.state.currentSize = size;
            this.state.currentView = this.state.screens[this.state.screenSize];
            this.state.allBrandSliders.forEach((k) => (k.style.transform = 'translateX(0)'));
            this.state.enableScroll = this.state.blockTotal > this.state.currentView[1];
            this.state.offset = 0;
            setAttributes(this.state.target, {
                'data-offset': this.state.offset,
                'data-view': this.state.currentView,
            });

            Array.from(this.state.target.getElementsByClassName('js--f-right')).forEach(
                ({ classList }) =>
                    this.state.enableScroll
                        ? classList.remove(this.state.disabled)
                        : classList.add(this.state.disabled),
            );

            Array.from(this.state.target.getElementsByClassName('js--f-left')).forEach((k) =>
                k.classList.remove(this.state.disabled),
            );
        }

        if (brandSize !== this.state.currentBrandSize || val === 'reset') {
            const [, brandView] = this.state.brandScreens[this.state.screenSize];

            this.state.currentBrandSize = brandSize;
            this.state.currentBrandView = brandView;
            this.state.allBrandSliders.forEach((k) => (k.style.transform = 'translateX(0)'));
            this.state.offset = 0;
            this.state.enableScroll = this.state.blockTotal > this.state.currentView[1];

            setAttributes(this.state.target, {
                'data-offset': this.state.offset,
                'data-view': this.state.currentBrandView,
            });

            Array.from(this.state.target.getElementsByClassName('js--f-right')).forEach(
                ({ classList }) =>
                    this.state.enableScroll
                        ? classList.remove(this.state.disabled)
                        : classList.add(this.state.disabled),
            );

            Array.from(this.state.target.getElementsByClassName('brand-slider__left-btn')).forEach(
                (k) => k.classList.add(this.state.disabled),
            );
        }

        this.checkBrandScroll();
    }

    brandSlider() {
        const brandRight =
            this.state.brandRight ||
            this.state.target.getElementsByClassName('brand-slider__right')[0];

        if (!this.state.brandRight) {
            this.state.brandRight = brandRight;
        }

        clearInterval(this.state.sliderInterval);
        this.state.sliderInterval = setInterval(() => {
            if (brandRight.classList.contains('brand-slider__arrow--disabled')) {
                this.gridResize('reset');
            } else {
                simulateClick(brandRight);
            }
        }, this.state.interval);
    }

    toggleArrows(display = false) {
        const [scrollContainer] = this.state.target.getElementsByClassName(
            'brand-slider__scroll-wrapper',
        );

        this.state.arrow.forEach(({ classList }) =>
            display ? classList.remove('none') : classList.add('none'),
        );

        return display
            ? scrollContainer.classList.remove('brand-slider__scroll-wrapper--disabled')
            : scrollContainer.classList.add('brand-slider__scroll-wrapper--disabled');
    }

    checkBrandScroll() {
        this.toggleArrows(this.state.enableScroll);
        return this.state.enableScroll
            ? this.brandSlider()
            : clearInterval(this.state.sliderInterval);
    }

    // ==================================================
    // INITIALIZERS
    // ==================================================

    init() {
        this.state.screenSize = `vw${parseInt(
            getComputedStyle(document.getElementsByClassName('js--fp-width')[0])['max-width'],
            10,
        )}`;

        const { generalSize, generalView } = this.state.screens[this.state.screenSize];
        const { brandSize, brandView } = this.state.brandScreens[this.state.screenSize];

        this.state.currentSize = generalSize;
        this.state.currentView = generalView;
        this.state.currentBrandSize = brandSize;
        this.state.currentBrandView = brandView;
        this.state.blockTotal = parseInt(this.state.target.getAttribute('data-blocks'), 10);
        this.state.interval = parseInt(
            this.state.target.getElementsByClassName('js--brands-interval')[0].innerHTML,
            10,
        );

        this.state.arrow.forEach((k) =>
            k.addEventListener('click', (e) => {
                e.preventDefault();
                this.slider(e.target);
            }),
        );

        window.addEventListener('resize', (e) => {
            e.preventDefault();
            this.throttleOrDie();
        });

        this.checkBrandScroll();
        this.state.target.addEventListener('mouseover', () =>
            clearInterval(this.state.sliderInterval),
        );
        this.state.target.addEventListener('mouseout', () => this.checkBrandScroll());
        this.gridResize('reset');
    }
}

// ==================================================
// INIT
// ==================================================

function init() {
    const arr = [];

    Array.from(document.getElementsByClassName('brand-slider')).forEach((k) => {
        arr.push(() => new BrandSlider(k).init());
    });

    arr.forEach((k) => k());
}

export default init;
